/**
 * BLIK wordmark — official brand SVG (letters `blik` + the trademark
 * gradient dot atop the "i", `#FF0000 → #E83E49 → #FF00FF`).
 *
 * Rendered as inline SVG (not a PNG) so it stays crisp at any DPR.
 * Colors are brand-locked:
 *   - letterforms: solid white (BLIK-approved on dark backgrounds).
 *     Kept as literal `#FFFFFF` — do NOT switch to `currentColor`;
 *     that would let callers de-brand the mark.
 *   - dot: the red-magenta radial gradient defined below.
 *
 * The gradient id is namespaced (`blikDotGradient`) so it survives
 * SSR/DOM dedup and doesn't collide if the button re-renders multiple
 * times on the same page.
 */
export const BlikWordmark = (): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="24"
    viewBox="0 0 32 16"
    fill="none"
    role="img"
    aria-label="blik"
  >
    <path d="M14.714 0.74849H12.0121V15.8856H14.714V0.74849Z" fill="#FFFFFF" />
    <path d="M19.7272 5.85889H17.0253V15.8852H19.7272V5.85889Z" fill="#FFFFFF" />
    <path
      d="M31.8369 15.8856L27.7768 10.5795L31.5114 5.85934H28.3212L24.7404 10.4386V0.74849H22.0385V15.8856H24.7404V10.7379L28.3212 15.8856H31.8369Z"
      fill="#FFFFFF"
    />
    <path
      d="M5.12715 5.74583C4.24976 5.74583 3.42409 5.96666 2.70192 6.35511V0.749026H0V10.873C0 13.7046 2.2955 16 5.12706 16C7.95861 16 10.2541 13.7045 10.2541 10.873C10.2541 8.04143 7.9587 5.74583 5.12715 5.74583ZM5.12715 13.2981C3.78774 13.2981 2.70192 12.2123 2.70192 10.8729C2.70192 9.53348 3.78774 8.44767 5.12715 8.44767C6.46655 8.44767 7.55237 9.53348 7.55237 10.8729C7.55237 12.2123 6.46655 13.2981 5.12715 13.2981Z"
      fill="#FFFFFF"
    />
    <path
      d="M7.76391 4.81786C9.09433 4.81786 10.1728 3.73935 10.1728 2.40893C10.1728 1.07851 9.09433 0 7.76391 0C6.43349 0 5.35498 1.07851 5.35498 2.40893C5.35498 3.73935 6.43349 4.81786 7.76391 4.81786Z"
      fill="url(#blikDotGradient)"
    />
    <defs>
      <radialGradient
        id="blikDotGradient"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(5.80532 -0.130178) scale(7.89772)"
      >
        <stop stopColor="#FF0000" />
        <stop offset="0.495" stopColor="#E83E49" />
        <stop offset="1" stopColor="#FF00FF" />
      </radialGradient>
    </defs>
  </svg>
);
